/**
 * @generated SignedSource<<275e0660f62e474f92503c6a5b5a420a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastAdminPopoverSectionStore_Store$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "StorecastAdminPopoverSectionStore_Store";
};
export type StorecastAdminPopoverSectionStore_Store$key = {
  readonly " $data"?: StorecastAdminPopoverSectionStore_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminPopoverSectionStore_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastAdminPopoverSectionStore_Store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "b5a6d5a1eed6ba6cdb624373496141e7";

export default node;
